import { ReactElement } from 'react';
import { FieldValues } from 'react-hook-form';

import CustomEntityForm, {
  EntityFormProps,
} from '@/components/controls/CustomEntityForm.tsx';

export interface EntityFormModalProps<T extends FieldValues>
  extends EntityFormProps<T> {
  isOpen: boolean;
  onClose: () => void;
}

function CustomEntityFormModal<T extends FieldValues>({
  isOpen,
  onClose,
  schema,
  entityData,
  initialMode,
  fields,
  onSubmit,
  onCancel,
  title,
  isLoading,
}: EntityFormModalProps<T>): ReactElement | null {
  if (!isOpen) return null;

  const handleCancel = (): void => {
    onCancel();
    onClose();
  };

  return (
    <div className="fixed inset-0 z-49 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative bg-white rounded-lg shadow-lg p-6 w-[calc(100%-2rem)] sm:w-full max-w-lg max-h-[90vh] overflow-y-auto">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-honoursOrange hover:text-honoursOrange/90 text-xl"
          type="button"
          aria-label="Close"
        >
          <i className="pi pi-times" />
        </button>

        <CustomEntityForm
          schema={schema}
          entityData={entityData}
          initialMode={initialMode}
          fields={fields}
          onSubmit={onSubmit}
          onCancel={handleCancel}
          title={title}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
}

export default CustomEntityFormModal;
